module.exports = __webpack_public_path__ + "img/heart-icon-evaluation.da627fef.svg";